import { Route } from "react-router-dom";
import UserManagement from "./../User-Management/UserManagement";
import UserAccessPage from "./../User-Management/UserAccessPage";

const AdminRoutes = (
  <Route>
    <Route path="/user-management" element={<UserManagement />} />
    <Route path="/user-management/user-access" element={<UserAccessPage />} />
  </Route>
);

export default AdminRoutes;